import React from 'react'

const PayperviewPaidSkeleton = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    return (
        <div className='grid w-full grid-cols-2 mt-4 mb-28 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 max-sm:w-full'>
            {arr.map((item: any) => (
                <div key={item} className='mb-5 mr-4'>
                    <div className='w-full overflow-hidden rounded-xl'>
                        {/* banner — matches PayPerViewCard's aspect-video image area */}
                        <div className='aspect-video w-full animate-pulse rounded-xl bg-[#1a1919]'></div>

                        {/* content — mirrors title / date-category / footer lines */}
                        <div className='px-1 pb-4 pt-[14px]'>
                            <div className='h-[17px] w-4/5 animate-pulse rounded bg-[#1a1919]'></div>
                            <div className='mt-2 flex items-center justify-between gap-2'>
                                <div className='h-[12px] w-2/5 animate-pulse rounded bg-[#1a1919]'></div>
                                <div className='h-[18px] w-1/4 animate-pulse rounded-full bg-[#1a1919]'></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default PayperviewPaidSkeleton
